import { Constants } from 'src/app/shared/model/Constants';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { DocumentInfo } from '../../models/DocumentInfo';
import { DocumentService } from '../../service/document.service';

@Component({
  selector: 'app-show-document',
  templateUrl: "./show-document.component.html",
  styleUrls: ["./show-document.component.scss"],
})
export class ShowDocumentComponent extends DialogContentBase implements OnInit {
  content: any;
  isImage: boolean;
  isText: boolean;
  isPdf: boolean;
  isUnknown: boolean;
  contentType: string;
  downloadUrl: string;
  zoomMode = false;

  constructor(
    public dialog: DialogRef,
    private documentService: DocumentService
  ) {
    super(dialog);
  }

  @Input() documentInfo: DocumentInfo;
  @Input() documentInfoCollection: DocumentInfo[];
  @Input() documentContent: Blob;
  @Input() fileExtension: string;
  @Input() fileName: string;
  @Input() canExport = true;

  private imageRotatedEvent = new EventEmitter<any>();
  public imageRotated$ = this.imageRotatedEvent.asObservable();

  currentCollectionIndex = 0;
  collectionSize = 0;

  ngOnInit(): void {
    if (this.documentInfoCollection) {
      this.collectionSize = this.documentInfoCollection?.length;
      this.currentCollectionIndex = this.documentInfoCollection.findIndex(
        (d) => d.id == this.documentInfo.id
      );
    }
  }

  nextPhoto() {
    if (this.currentCollectionIndex < this.documentInfoCollection.length) {
      this.documentInfo =
        this.documentInfoCollection[++this.currentCollectionIndex];
    }
  }

  prevPhoto() {
    if (this.currentCollectionIndex > 0) {
      this.documentInfo =
        this.documentInfoCollection[--this.currentCollectionIndex];
    }
  }

  rotateLeft(): void {
    this.documentService
      .rotateDocument(this.documentInfo.id, Constants.Degrees270)
      .subscribe((res) => {
        this.documentContent = res.fileContent;
        this.imageRotatedEvent.emit({
          id: this.documentInfo.id,
          thumb: res.thumb,
        });
      });
  }

  rotateRight(): void {
    this.documentService
      .rotateDocument(this.documentInfo.id, Constants.Degrees90)
      .subscribe((res) => {
        this.documentContent = res.fileContent;
        this.imageRotatedEvent.emit({
          id: this.documentInfo.id,
          thumb: res.thumb,
        });
      });
  }

  toogleImageMode(): void {
    this.zoomMode = !this.zoomMode;
  }
}
